import ApiService from './ApiService';

class ShareKnowledgeApi extends ApiService {
    constructor() {
        super('share-knowledge');
    }
    getFilesGroup(payload) {
        return this.get('group/file', payload);
    }
    createRequest(payload) {
        return this.post('group/request', payload);
    }
    getGroupInfo(payload) {
        return this.get('group/info', payload);
    }
    createFile(payload) {
        return this.post('group/file', payload);
    }
    updateFile(payload) {
        return this.put(`group/file/${payload.id}`, payload);
    }
    deleteFile(payload) {
        return this.delete('group/file', payload);
    }
    getFileInfo(payload) {
        return this.get(`group/file/info/${payload}`);
    }
    getAllRequestForGA(payload) {
        return this.get('request', payload);
    }
    getAllFileShareknowledge(payload) {
        return this.get('file', payload);
    }
    getPresignedUrlsDonwload(payload){
        return this.get('group/file/download', payload);
    }
    getPresignedUrls(payload) {
        return this.post('group/file/presigned-url', payload);
    }
    getConfigs(payload) {
        return this.get('config', payload);
    }
    getGroupRequest(payload) {
        return this.get('group/request', payload);
    }
    viewFileProgress(id, payload) {
        return this.post(`file/${id}/view-progress`, payload);
    }
    getFileViewers(fileId, payload) {
        return this.get(`group/file/${fileId}/viewers`, payload);
    }
    exportFileViewersCsv(fileId, payload) {
        return this.get(`group/file/${fileId}/viewers/export`, payload, null, 'blob');
    }
}

export default ShareKnowledgeApi;
